export const REPEAT_INTERVAL = [
  // { label: 'Daily', value: 'daily' },
  // { label: 'Weekdays', value: 'weekdays' },
  // { label: 'Weekends', value: 'weekends' },
  // { label: 'Nope' },
  { label: 'Every Monday', value: '1' },
  { label: 'Every Tuesday', value: '2' },
  { label: 'Every Wednesday', value: '3' },
  { label: 'Every Thursday', value: '4' },
  { label: 'Every Friday', value: '5' },
  { label: 'Every Saturday', value: '6' },
  { label: 'Every Sunday', value: '0' },
]
